import { render, staticRenderFns } from "./QueryItems.vue?vue&type=template&id=9dd9be6a&scoped=true"
import script from "./QueryItems.vue?vue&type=script&lang=js"
export * from "./QueryItems.vue?vue&type=script&lang=js"
import style0 from "./QueryItems.vue?vue&type=style&index=0&id=9dd9be6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd9be6a",
  null
  
)

export default component.exports